import { render } from "./NotiDonate.vue?vue&type=template&id=51dd9788&scoped=true"
import script from "./NotiDonate.vue?vue&type=script&lang=js"
export * from "./NotiDonate.vue?vue&type=script&lang=js"

import "./NotiDonate.vue?vue&type=style&index=0&id=51dd9788&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd9788"]])

export default __exports__